import React from 'react';
import { INK } from './constants';

export function Description({ text }: { text: string }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16, padding: '16px' }}>
      <p style={{ margin: 0, fontSize: 16, fontWeight: 500, lineHeight: '20.8px', color: INK }}>Description</p>
      <p style={{ margin: 0, fontSize: 14, fontWeight: 400, lineHeight: '20px', color: INK, whiteSpace: 'pre-line' }}>
        {text}
      </p>
    </div>
  );
}
